// gère la fermeture de la modal d'affichage des prévisions

import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    document.addEventListener("keydown", this.handleEscape);
    this.modalElement = document.getElementById("global-modal");

    // Ajouter l'écouteur d'événement pour le déplacement de la carte
    if (window.map) {
      window.map.on("dragstart", this.handleMapDrag.bind(this));
    }

    // Écouter spécifiquement le clic sur le bouton close
    this.boundHandleCloseClick = this.handleCloseButtonClick.bind(this);
    document.addEventListener('click', this.boundHandleCloseClick);
  }

  disconnect() {
    document.removeEventListener("keydown", this.handleEscape);

    // Retirer l'écouteur d'événement lors de la déconnexion
    if (window.map) {
      window.map.off("dragstart", this.handleMapDrag.bind(this));
    }

    // Nettoyer l'event listener
    document.removeEventListener('click', this.boundHandleCloseClick);
  }

  close() {
    this.modalElement?.classList.remove("open");
  }

  // Fermeture par le bouton close → restaurer le panel
  closeWithRestore() {
    this.close();
    this.restoreSessionPanel();
  }

  handleEscape = (event) => {
    if (event.key === "Escape") {
      this.close(); // Pas de restauration pour Escape
    }
  };

  handleMapDrag = () => {
    this.close(); // Pas de restauration pour drag
  };

  // Méthode pour gérer le clic sur le bouton close
  handleCloseButtonClick(event) {
    if (event.target.classList.contains('forecast-modal-close')) {
      console.log('🔘 Close button clicked - restoring session panel');
      this.closeWithRestore(); // Fermeture avec restauration
    }
  }

  // Méthode pour restaurer le panel de session
  restoreSessionPanel() {
    const isMobile = window.innerWidth <= 768;

    // Seulement sur mobile et seulement si le panel était caché par notre action
    if (isMobile && localStorage.getItem('sessionDisplayed') === "false") {
      const sessionElement = document.querySelector('#session');
      if (sessionElement && typeof window.add_panel === 'function') {
        window.add_panel(sessionElement);
        console.log('📱 Session panel restored on mobile');
      }
    }
  }
}
